import { useMemo } from 'react';

import { useAgentTweakableCopilotIntegration } from '@/features/copilot/agent-tweakable';
import { useCareStateDomain } from '@/entities/care-state-domain';

import { CopilotToolRegistry } from './ToolRegistry';
import {
  createCreateProposedActionToolSpec,
  createDeleteProposedActionToolSpec,
  createUpdateProposedActionPayloadToolSpec,
} from './tools/modify-proposed-actions';

/**
 * Hook that provides the Copilot tool registry with all registered tools.
 */
export function useCopilotToolRegistry() {
  const { agentTweakableToolSpecs } = useAgentTweakableCopilotIntegration();
  const { patientUserId } = useCareStateDomain();

  const registry = useMemo(() => {
    const specs = [
      createCreateProposedActionToolSpec(patientUserId),
      createUpdateProposedActionPayloadToolSpec(patientUserId),
      createDeleteProposedActionToolSpec(patientUserId),
      ...agentTweakableToolSpecs,
    ];
    return new CopilotToolRegistry(specs);
  }, [agentTweakableToolSpecs, patientUserId]);

  return { registry };
}
